import React, { useEffect, useMemo, useRef, useState } from 'react';
import Tips from '../../../components/Request/Tips';
import Wrapper from './Wrapper';
import _ from 'lodash';
import { useProps } from '../../../hooks/useProps';
import { COMMON_TAGS_MODEL_TYPES, MODEL_TYPES } from '../../../constants/constants';
import { PageSearchBar } from '../../../common/UniversalSearchForm/UniversalSearchForm';
import styles from './Select3dModel.module.scss';
import InfiniteScroll from '../../../components/InfiniteScroll/InfiniteScroll';
import { useUserContext } from '../../../contexts/UserContext';
import icons from '../../../assets';
import RequestThumbnailCardUI from './RequestThumbnailCardUI';
import { IMAGINE_ORG_ID } from '../../../constants/projectConstants';
import { ActionFilters, Checkbox } from '../../../common';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import {
  requestsSelector,
  setNextButtonEnabled,
  setSelectedProduct,
} from '../../../redux/slicers/requestSlicer';
import { apiUpdateRequest } from '../../../helpers/api';

function Select3DModel(modelType = MODEL_TYPES.PRODUCT) {
  const _requestSelector = useSelector(requestsSelector);
  const [selected, setSelected] = useState(_requestSelector.selectedProduct);
  const [isImagineLibrary, setIsImagineLibrary] = useState(false);
  const [filter, setFilter] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const TIP_TEXT =
    'You can choose a product from your exclusive props list or you can request a variation from our library too. \n \n Variation can be based on structure or texture finish.';

  const CATEGORY_ID = 1;

  const { isGuestUser } = useUserContext();
  const dispatch = useDispatch();

  const { FilterIcon } = icons;

  const requestParams = useMemo(
    () => ({
      ...(filter?.length && { fl_1: filter.toString() }),
      brands: !isImagineLibrary ? '' : IMAGINE_ORG_ID,
    }),
    [filter, isImagineLibrary]
  );

  const dataRef = useRef();

  const {
    list,
    loading,
    refetchList,
    fetchMoreData,
    hasMore,
    hasData,
    search,
    onSearchChange,
    data,
  } = useProps({
    requestParams,
    modelType,
  });

  const filters = data?.sidefilter?.filteroptions.filter(
    (item) => item.filter_label === CATEGORY_ID
  );

  filters?.unshift({ id: 0, name: 'Select all' });

  const handleClick = ({id}) => {
    setSelected(id);
    dispatch(setSelectedProduct(id));
    dispatch(setNextButtonEnabled(true));
    dataRef.current = id;
  };

  const handleCheck = () => {
    setIsImagineLibrary(!isImagineLibrary);
    setFilter([]);
  };

  const handleFilterCheck = (_id) => {
    let _filter = [];
    if (_id === 0) {
      if (!filter.includes(_id)) _filter = filters.map((item) => item.id);
    } else {
      if (filter.includes(_id)) _filter = filter.filter((item) => ![_id, 0].includes(item));
      else _filter = [...filter, _id];
    }

    setFilter(_filter);
    setShowFilters(false);
    refetchList();
  };

  const handleFilterIconClick = (event) => {
    event.stopPropagation();
    setShowFilters(!showFilters);
  };

  window.addEventListener('click', () => {
    setShowFilters(false);
  });

  const handleFilterWrapperClick = (event) => {
    event.stopPropagation();
  };

  useEffect(() => {
    if (!selected) dispatch(setNextButtonEnabled(false));
    else dispatch(setNextButtonEnabled(true));

    return async () => {
      if (dataRef.current) {
        const formData = new FormData();
        formData.append('product', dataRef.current);

        if(isGuestUser()) {
          formData.append('is_internal_team', true);
        }

        await apiUpdateRequest(_requestSelector.currentRequestId, formData);
      }
    };
  }, []);

  return (
    <Wrapper title="Please select the 3d model file you want to use ">
      <div className={cx('d-flex gap-4', styles.wrapper)}>
        <div className={cx('mt-3', styles.subWrapper)}>
          <div className="d-flex gap-3">
            <PageSearchBar
              model={COMMON_TAGS_MODEL_TYPES.PRODUCT}
              onSearchChange={onSearchChange}
              search={search}
              hideTags
            />
            <div className={styles.filterWrapper}>
              <Checkbox
                name="imagine-library"
                onChange={handleCheck}
                label="Show Imagine library"
                selected={isImagineLibrary}
                className={styles.checkBox}
              />
            </div>

            <div className={styles.filterWrapper}>
              <div onClick={handleFilterIconClick} className="d-flex gap-2">
                <FilterIcon />
                Filter
              </div>
              {showFilters && filters?.length && (
                <div className={styles.filters} onClick={handleFilterWrapperClick}>
                  {filters.map((item) => (
                    <div>
                      <Checkbox
                        name="filter"
                        key={item.id}
                        onChange={() => handleFilterCheck(item.id)}
                        label={item.name}
                        selected={filter.includes(item.id)}
                        className={styles.checkBox}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <InfiniteScroll
            dataLength={list.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loading={loading}
            hasChildren={hasData}
            scrollableTarget="infiniteScroll"
            className="py-3">
            <RequestThumbnailCardUI
              list={list}
              selected={selected}
              onCardClick={handleClick}
              loading={loading}
            />
          </InfiniteScroll>
        </div>
        <Tips title="3d file" text={TIP_TEXT} showImages={false} marginTop={6} />
      </div>
    </Wrapper>
  );
}

export default Select3DModel;
